export const HEADER_BANNER_DATA_TEST_ID = 'header-banner';
export const HEADER_BANNER_DESKTOP_DATA_TEST_ID = 'header-banner-desktop';
export const HEADER_BANNER_LINK_DATA_TEST_ID = 'header-banner-link';
